import { createAction } from 'typesafe-actions';
import { IUssdTransactionStatus } from '../../constants';

export const updateUssdTransaction = createAction(
  'UPDATE_USSD_TRANSACTION',
  (ussdTransaction: IUssdTransactionStatus) => ussdTransaction,
)();
